import React from 'react';
import { Users, MessageSquareOff, Target, RefreshCw, TrendingUp, Layers, Bot } from 'lucide-react';
import { challenges } from '../data/mock';

const iconMap = {
  Users: Users,
  MessageSquareOff: MessageSquareOff,
  Target: Target,
  RefreshCw: RefreshCw,
  TrendingUp: TrendingUp,
  Layers: Layers,
  Bot: Bot
};

const Challenges = () => {
  return (
    <section id="challenges" className="py-16 sm:py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-amber-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Common Obstacles
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            The Challenges Organizations
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-400">
              Are Facing Today
            </span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto">
            These issues don't just affect HR—they impact productivity, morale, retention, 
            and long-term growth across your entire organization.
          </p>
        </div>

        {/* Challenges Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
          {challenges.map((challenge, index) => {
            const IconComponent = iconMap[challenge.icon];
            return (
              <div
                key={challenge.title}
                className={`group p-5 sm:p-6 rounded-2xl bg-slate-950/50 border border-slate-800 hover:border-amber-500/30 transition-all duration-300 hover:-translate-y-1 ${
                  index === 6 ? 'sm:col-span-2 lg:col-span-1 xl:col-span-1' : ''
                }`}
              >
                <div className="w-11 h-11 rounded-xl bg-amber-500/10 flex items-center justify-center mb-4 group-hover:bg-amber-500/20 transition-colors">
                  <IconComponent className="h-5 w-5 text-amber-400" />
                </div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 group-hover:text-amber-400 transition-colors leading-tight">
                  {challenge.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {challenge.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12 sm:mt-16 p-6 rounded-2xl bg-slate-950/30 border border-slate-800">
          <p className="text-slate-300 text-base sm:text-lg">
            <span className="text-cyan-400 font-semibold">Sound familiar?</span> These challenges are solvable with the right strategy, training, and support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Challenges;
